import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetQrData = createAsyncThunk(
    'GenerateQR/GetQrDetails',
    async ({searchvalue}, { rejectWithValue }) => {
      try { 
        const response = await apiClient.get(`GetQRData/GetQRData?SEARCHTEXT=${searchvalue}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );